import React, { useEffect, useState } from "react";
import { Bot } from "lucide-react";
import api from "../api";

function Card({ children, className = "" }) {
  return <div className={`rounded-2xl border border-slate-200 bg-white p-5 shadow-sm md:p-6 ${className}`}>{children}</div>;
}

export default function CamiManager() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/cami/stats").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <div className="text-sm text-slate-400">Loading…</div>;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <Card>
          <div className="flex items-start justify-between"><span className="text-xs font-semibold uppercase tracking-wide text-slate-400">Chat sessions</span><Bot className="h-4 w-4 text-violet-500" /></div>
          <div className="mt-3 text-2xl font-bold text-slate-900">{data.sessions}</div>
        </Card>
        <Card>
          <div className="flex items-start justify-between"><span className="text-xs font-semibold uppercase tracking-wide text-slate-400">Messages exchanged</span><Bot className="h-4 w-4 text-violet-500" /></div>
          <div className="mt-3 text-2xl font-bold text-slate-900">{data.messages}</div>
        </Card>
      </div>
      <Card>
        <h2 className="text-base font-bold text-slate-900">Cami knowledge (system prompt)</h2>
        <p className="text-sm text-slate-500">The instructions and facts Cami uses to answer applicants.</p>
        <pre className="mt-3 max-h-64 overflow-auto whitespace-pre-wrap rounded-xl bg-slate-50 p-4 text-xs text-slate-600">{data.system_prompt}</pre>
      </Card>
      <Card>
        <h2 className="text-base font-bold text-slate-900">Recent messages</h2>
        <div className="mt-3 space-y-2">
          {data.recent.map((m, i) => (
            <div key={i} className="rounded-lg border border-slate-100 p-2 text-sm"><span className={`mr-2 rounded px-1.5 py-0.5 text-[11px] font-semibold ${m.role === "user" ? "bg-slate-100 text-slate-600" : "bg-violet-100 text-violet-700"}`}>{m.role}</span><span className="text-slate-700">{m.text}</span></div>
          ))}
          {data.recent.length === 0 && <div className="text-sm text-slate-400">No conversations yet.</div>}
        </div>
      </Card>
    </div>
  );
}
